/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-sale-credit-payment-tracker.reducer';

export const PharmacySaleCreditPaymentTrackerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacySaleCreditPaymentTrackerEntity = useAppSelector(state => state.pharmacySaleCreditPaymentTracker.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacySaleCreditPaymentTrackerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.detail.title">
            PharmacySaleCreditPaymentTracker
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.id}</dd>
          <dt>
            <span id="settledAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.settledAmount">Settled Amount</Translate>
            </span>
            <UncontrolledTooltip target="settledAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.settledAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.settledAmount}</dd>
          <dt>
            <span id="transactionType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.transactionType">Transaction Type</Translate>
            </span>
            <UncontrolledTooltip target="transactionType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.transactionType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.transactionType}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.addedById">Added By Id</Translate>
            </span>
            <UncontrolledTooltip target="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.addedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.modifiedById">Modified By Id</Translate>
            </span>
            <UncontrolledTooltip target="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.modifiedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.addedByType">Added By Type</Translate>
            </span>
            <UncontrolledTooltip target="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.addedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.modifiedByType">Modified By Type</Translate>
            </span>
            <UncontrolledTooltip target="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.modifiedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.modifiedByType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.lastUpdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.refundPayment">Refund Payment</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.refundPayment ? pharmacySaleCreditPaymentTrackerEntity.refundPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.salePayment">Sale Payment</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.salePayment ? pharmacySaleCreditPaymentTrackerEntity.salePayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.parentCredit">Parent Credit</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.parentCredit ? pharmacySaleCreditPaymentTrackerEntity.parentCredit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.pharmacy ? pharmacySaleCreditPaymentTrackerEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.payedCredit">Payed Credit</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.payedCredit ? pharmacySaleCreditPaymentTrackerEntity.payedCredit.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.consumer">Consumer</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.consumer ? pharmacySaleCreditPaymentTrackerEntity.consumer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCreditPaymentTracker.patient">Patient</Translate>
          </dt>
          <dd>{pharmacySaleCreditPaymentTrackerEntity.patient ? pharmacySaleCreditPaymentTrackerEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-sale-credit-payment-tracker" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/pharmacy-sale-credit-payment-tracker/${pharmacySaleCreditPaymentTrackerEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacySaleCreditPaymentTrackerDetail;
